import { render } from "./pcInterface.vue?vue&type=template&id=35958b5d&scoped=true"
import script from "./pcInterface.vue?vue&type=script&lang=js"
export * from "./pcInterface.vue?vue&type=script&lang=js"

import "./pcInterface.vue?vue&type=style&index=0&id=35958b5d&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35958b5d"]])

export default __exports__